import { navigationRef } from "../RootNavigation";

export const toDashboard = () =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Home",
      params: {
        screen: "DashboardScreen",
      },
    },
  });

export const toMyEvents = () =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "MyEvents",
      params: { screen: "Events" },
    },
  });

export const toEventDetail = (groupCode: string) =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "MyEvents",
      params: { screen: "EventDetail", params: { groupCode } },
    },
  });

export const toTicketBarcodes = (groupCode: string) =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "MyEvents",
      params: { screen: "Barcode", params: { groupCode } },
    },
  });

export const toSeatSelection = () =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Schedule",
      params: {
        screen: "SeatSelection",
      },
    },
  });

export const toTflSeatSelection = () =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Schedule",
      params: {
        screen: "TflSeatSelection",
      },
    },
  });

export const toScehdule = () =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Schedule",
      params: {
        screen: "ScheduleScreen",
      },
    },
  });

export const toAddNewPlan = (memberId: string) =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Account",
      params: {
        screen: "ManageSubscriptions",
        params: {
          screen: "AddNewPlan",
          params: {
            memberId: memberId,
          },
        },
      },
    },
  });

export const toAddNewPlanWithPlanPackageId = (
  memberId: string,
  planPackageId: string
) => {
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Account",
      params: {
        screen: "ManageSubscriptions",
        params: {
          screen: "AddNewPlanWithPlanPackageId",
          params: {
            memberId: memberId,
            planPackageId,
          },
        },
      },
    },
  });
};

export const toLogOut = () =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "LogOut",
  });

export const toManageMemberSubscription = (memberId: string) =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Account",
      params: {
        screen: "ManageSubscriptions",
        params: {
          screen: "SubscriptionDetail",
          params: { memberId },
        },
      },
    },
  });

export const toGiftPage = (planId: number) =>
  navigationRef.navigate("BuyGift", { planPackageId: planId });

export const toEventAvailablitiesPage = (eventName: string) =>
  navigationRef.navigate("AuthenticatedFlow", {
    screen: "MainFlow",
    params: {
      screen: "Schedule",
      params: {
        screen: "EventAvailablityDetails",
        params: {
          eventName,
        },
      },
    },
  });
